import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLine, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

export const ComingSoon = ({ eyebrow, pageTestid }) => {
  const { t } = useLanguage();
  return (
    <main data-testid={pageTestid} className="flex min-h-[85vh] flex-col justify-center pt-28">
      <div className="mx-auto w-full max-w-[1800px] px-4 pb-24 sm:px-8 lg:px-16">
        <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-gold sm:text-xs">
          {eyebrow}
        </p>
        <h1 className="mt-4 font-display text-6xl font-light uppercase leading-[0.95] tracking-tight text-ivory sm:text-8xl lg:text-9xl">
          <MaskedLine delay={0.1}>
            <span className="italic text-gold">{t("soon.title")}</span>
          </MaskedLine>
        </h1>
        <FadeUp delay={0.3}>
          <p className="mt-8 max-w-xl font-display text-xl font-light italic leading-relaxed text-white/75 sm:text-2xl">
            {t("soon.body")}
          </p>
        </FadeUp>
        <FadeUp delay={0.4}>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/discover"
              data-testid={`${pageTestid}-discover-link`}
              className="group flex items-center gap-3 bg-ivory px-8 py-4 font-mono text-xs uppercase tracking-[0.3em] text-black transition-colors duration-300 hover:bg-gold"
            >
              {t("home.discover")}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
            <Link
              to="/contact"
              data-testid={`${pageTestid}-contact-link`}
              className="flex items-center gap-3 border border-white/30 px-8 py-4 font-mono text-xs uppercase tracking-[0.3em] text-white transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              {t("nav.contact")}
            </Link>
          </div>
        </FadeUp>
      </div>
    </main>
  );
};
